import React, {useState, useEffect} from 'react'
import { Input } from "antd";

const ObservationDescriptionInput = ({
    formState,
    setFormState,
    generalValidations,
    setGeneralValidations
}) => {
    const [maxChar, setMaxChar] = useState("0");
    const data = formState.observationDescription;

    useEffect(() => {
        let mounted = true;

        if(mounted)
            setMaxChar(formState.observationDescription.length);

        return () => {
            mounted = false;
        }
    }, [data, formState.observationDescription])

    return (
        <>
            <Input.TextArea
                placeholder="Enter observation description (max length 300 characters)"
                onChange={(e) => {
                    setFormState(prevState => ({ ...prevState, observationDescription: e.target.value}))
                    setMaxChar(e.target.value.length);
                    if(generalValidations.observationDescription !== "")
                        setGeneralValidations(prevState => ({ ...prevState, observationDescription: "" }))    
                }}
                value={formState.observationDescription}
                maxLength={300}
                style={{
                    resize: "none",
                    height: "100px",
                    marginTop: "8px",
                    paddingBottom: "20px"
                }}
                className={generalValidations.observationDescription !== "" ? "newInputText validationInputText" : "newInputText"}
            />
            {generalValidations.observationDescription && 
                <span className="validationMessage">{generalValidations.observationDescription}</span>
            }
            <span className="maxCharMessage">{maxChar}/300</span>
        </>
    )
}

export default ObservationDescriptionInput
